import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, filter, switchMap, take, map, withLatestFrom, finalize, takeUntil } from 'rxjs';
import { environment } from '@environments/environment';
import { IResponseSuccess } from '../../interfaces';
import { Store as StoreModel } from '../../models';
import { Store } from '@ngrx/store';
import { selectAccountSlug, selectClientLocation, selectSlug, selectStore, selectStoreList } from '@store/selectors';
import { CORE_UPDATE_SLUG, STORE_FIND_ALL } from '@store/actions';
import { OrderTypeService } from '../order-type/order-type.service';
import { AppState } from '@store/reducers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root',
})
export class StoreService {
	// private readonly STORAGE_KEY_ACCOUNT_SLUG = 'currentAccountSlug';
	// private readonly STORAGE_KEY_STORE = 'currentStore';

	public currentSlug$ = new BehaviorSubject<string | null>(null);
	public currentAccountSlug$ = new BehaviorSubject<string | null>(null);
	private isLoading$ = new BehaviorSubject<boolean>(false);

	store$: Observable<StoreModel | null>;
	storeList$: Observable<StoreModel[] | null>;

	get loading$(): Observable<boolean> {
		return this.isLoading$.asObservable();
	}

	constructor(
		private http: HttpClient,
		private store: Store<AppState>,
		private orderTypeService: OrderTypeService
	) {
		this.store$ = this.store.select(selectStore);
		this.storeList$ = this.store.select(selectStoreList);

		this.store
			.select(selectSlug)
			.pipe(takeUntilDestroyed())
			.subscribe(slug => {
				this.currentSlug$.next(slug);
			});

		this.store
			.select(selectAccountSlug)
			.pipe(takeUntilDestroyed())
			.subscribe(accountSlug => {
				this.currentAccountSlug$.next(accountSlug);
			});
	}

	// public getStoredSlug(): string | null {
	// 	return this.currentSlug$.value ?? null;
	// }

	// public getStoredAccountSlug(): string | null {
	// 	return this.currentAccountSlug$.value ?? null;
	// }

	// private storeAccountSlug(accountSlug: string): void {
	// 	localStorage.setItem(`${this.STORAGE_KEY_ACCOUNT_SLUG}`, accountSlug);
	// }

	// private storeSlug(slug: string): void {
	// 	localStorage.setItem(`${this.STORAGE_KEY_STORE}`, slug);
	// }

	// setCurrentAccountSlug(accountSlug: string): void {
	// 	this.storeAccountSlug(accountSlug);
	// 	this.store.dispatch(STORE_FIND_ALL({ accountSlug }));
	// }

	// setCurrentSlug(slug: string): void {
	// 	this.store.dispatch(CORE_UPDATE_SLUG({ slug }));
	// 	this.currentSlug$.next(slug);
	// 	this.storeSlug(slug);
	// }

	getCurrentSlug(): string | null {
		return this.currentSlug$.value ?? null;
	}

	getCurrentAccountSlug(): string | null {
		return this.currentAccountSlug$.value ?? null;
	}

	find(slug: string): Observable<IResponseSuccess<StoreModel>> {
		return this.http.get<IResponseSuccess<StoreModel>>(`${environment.microConfiguraciones}/locales/olo/${slug}`);
	}

	findAll(): Observable<IResponseSuccess<StoreModel>> {
		return this.http.get<IResponseSuccess<StoreModel>>(`${environment.microConfiguraciones}/locales/olo`);
	}

	getStoreWithTimeAvailability(): Observable<StoreModel[]> {
		return this.store.select(selectStoreList).pipe(
			map(stores => {
				return (
					stores?.map(store => {
						const { delivery, pickup } = this.orderTypeService.checkOrderTypeAvailabilityByCurrentTime(
							store.order_type
						);
						return {
							...store,
							deliveryAvailable: delivery,
							pickUpAvailable: pickup,
						};
					}) ?? []
				);
			})
		);
	}

	findAllStores(params?: {
		limit?: number;
		offset?: number;
		cuentaId?: string;
		slug?: string | null;
	}): Observable<IResponseSuccess<StoreModel>> {
		this.isLoading$.next(true);

		// Set default params if not provided
		const queryParams = {
			limit: params?.limit || 100,
			offset: params?.offset || 0,
			...(params?.cuentaId && { cuentaId: params.cuentaId }),
			...(params?.slug && { slug: params.slug }),
		};

		return this.http
			.get<IResponseSuccess<StoreModel>>(`${environment.microConfiguraciones}/locales/cuenta/olo`, {
				params: queryParams,
			})
			.pipe(
				// When the request completes, set loading to false
				finalize(() => this.isLoading$.next(false))
			);
	}

	findById(id: string): Observable<IResponseSuccess<StoreModel>> {
		return this.store$.pipe(
			take(1),
			filter(storeData => !!storeData),
			switchMap(storeData =>
				this.http.get<IResponseSuccess<StoreModel>>(`${environment.microConfiguraciones}/locales/${id}`, {
					headers: {
						authorization: storeData.apiKey,
					},
				})
			)
		);
	}

	findStoresByUserLocation(): Observable<StoreModel[]> {
		return this.storeList$.pipe(
			filter(storeData => !!storeData),
			withLatestFrom(this.store.select(selectClientLocation)),
			map(([storeData, _clientLocation]) => {
				// storeData.map((store)=>{
				//   this.geolocationService.getCoordinatesFromAddress(store?.ubicacion?.direccion).subscribe((coordinates)=>{
				//     this.geolocationService.isPointInShape(clientLocation, coordinates)

				//   })

				// })

				return storeData;
			})
		);
	}
}
